import isNil from 'lodash/isNil';
import { SfdcDisplayType } from '../../../../types/fields';

export const isFormulaSupported = ({
  isRestrictedPicklist,
  sfDisplayType,
}: {
  sfDisplayType?: SfdcDisplayType;
  isRestrictedPicklist?: boolean;
}) => {
  if (!sfDisplayType) return false;

  switch (sfDisplayType) {
    case SfdcDisplayType.STRING:
    case SfdcDisplayType.TEXTAREA:
    case SfdcDisplayType.LONGTEXTAREA:
    case SfdcDisplayType.EMAIL:
    case SfdcDisplayType.PHONE:
    case SfdcDisplayType.URL:
    case SfdcDisplayType.DATETIME:
    case SfdcDisplayType.DATE:
    case SfdcDisplayType.BOOLEAN:
    case SfdcDisplayType.CURRENCY:
    case SfdcDisplayType.NUMBER:
    case SfdcDisplayType.PERCENT:
    case SfdcDisplayType.INTEGER:
    case SfdcDisplayType.DOUBLE:
    case SfdcDisplayType.ENCRYPTEDSTRING:
      return true;
    case SfdcDisplayType.PICKLIST:
    case SfdcDisplayType.MULTIPICKLIST:
      const isAllowed = isNil(isRestrictedPicklist) ? false : !isRestrictedPicklist;
      return isAllowed;

    default:
      return false;
  }
};
